<template>
  <div>
    <ProgressTracker></ProgressTracker>
    <section class="section has-text-centered" v-if="oldIE !== -1 || oldBrowser === true">
      <div class="container">
        <h1 class="title is-size-1">
          You have a very old web browser.
        </h1>
        <h2 class="title is-size-2">
          Unfortunately, that means this survey won't function properly for you.
          Please upgrade your browser to use this survey form.
        </h2>
      </div>
    </section>
    <section class="section has-text-centered" v-else-if="badSecret">
      <div class="container">
        <h1 class="title is-size-1 is-size-2-mobile">
          Invalid link!
        </h1>
        <h2 class="title is-size-2 is-size-4-mobile" v-html="badSecret" />
      </div>
    </section>
    <div class="container" v-else-if="notExpired">
      <Intro></Intro>
      <Rules></Rules>
      <form id="survey" name="survey" class="form" :class="labelsAbove">
        <Layout></Layout>
        <Signature></Signature>
        <Submit></Submit>
      </form>
    </div>
    <section id="expired" class="section has-text-centered" v-else>
      <div class="container">
        <h1 class="title is-size-1">
          Voting has expired!
        </h1>
      </div>
    </section>
  </div>
</template>

<script>
import Intro from '@/components/Intro.vue';
import Rules from '@/components/Rules.vue';
import Layout from '@/components/Layout.vue';
import Signature from '@/components/Signature.vue';
import Submit from '@/components/Submit.vue';
import ProgressTracker from '@/components/ProgressTracker.vue';

export default {
  components: {
    Intro,
    Rules,
    Layout,
    Signature,
    Submit,
    ProgressTracker,
  },
  computed: {
    notExpired() {
      return new Date() < new Date(this.$store.state.expiration_date);
    },
    oldIE() {
      if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
        return new Number(RegExp.$1); /* eslint-disable-line */
      }
      return -1;
    },
    oldBrowser() {
      return !(this.$store
        && this.$store.state
        && this.$store.state.submission
        && typeof this.$store.state.submission.set === 'function');
    },
    labelsAbove() {
      return this.$store.state.labels_above === true ? 'labelsAbove' : '';
    },
    badSecret() {
      const { prepopulate } = this.$store.state;
      const { secret } = this.$route.params;

      /**
       * If we're at the root and enableRoot is true, show the survey form
       * Otherwise, show the error. This means we're at the root and we
       * have root disabled in our config.
       *
       * If we have defined a `prepopulate.js`, and the secret we're visiting
       * exists in that file, show the survey form. `Input.js` handles the
       * auto-populating.
       */
      if (prepopulate === undefined) {
        return false;
      }

      if (
        (secret === undefined && prepopulate && prepopulate.enableRoot === true)
        || (prepopulate && prepopulate[secret])
      ) {
        return false;
      }
      return prepopulate.defaultError;
    },
  },
  mounted() {
    this.$store.dispatch('createUuid');
  },
};
</script>
